import { filterNames } from '../constants/common';

export const searchSelector = (state) => state.informationsStore.search;

export const filterVisibleSelector = (state) =>
  state.informationsStore.filterVisible;

export const periodSelector = (state) =>
  state.informationsStore[filterNames.period];
export const typesSelector = (state) =>
  state.informationsStore[filterNames.types];
export const companiesSelector = (state) =>
  state.informationsStore[filterNames.companies];
export const streetsSelector = (state) =>
  state.informationsStore[filterNames.streets];
export const housesSelector = (state) =>
  state.informationsStore[filterNames.houses];
export const addressesSelector = (state) =>
  state.informationsStore[filterNames.addresses];
export const onlyActiveSelector = (state) =>
  state.informationsStore[filterNames.onlyActive];

export const filterStateSelector = (state) => ({
  period: state.informationsStore.period,
  types: state.informationsStore.types,
  companies: state.informationsStore.companies,
  streets: state.informationsStore.streets,
  houses: state.informationsStore.houses,
  addresses: state.informationsStore.addresses,
  onlyActive: state.informationsStore.onlyActive,
});

export const selectedInfoSelector = (state) =>
  state.informationsStore.selectedInfo;

export const editorStateSelector = (state) => state.informationsStore.editorState;
export const editorLinkModalDataSelector = (state) =>
  state.informationsStore.editorLinkModalData;
export const editorPhoneModalDataSelector = (state) =>
  state.informationsStore.editorPhoneModalData;